/**
 * Vue Router 配置
 *
 * 路由表定义与守卫注册。
 * 守卫逻辑拆分到独立模块：
 *   - initSessionGuard:      首次导航时初始化会话
 *   - notFoundExternalRedirectGuard: 未找到路由外部承接
 *   - authCheckGuard:        认证状态检查与重定向
 *   - devProjectEntryGuard:  开发环境首页固定项目直达
 */

import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import AuthError from '../views/AuthError.vue';
import Editor from '../views/Editor.vue';
import Preview from '../views/Preview.vue';
import VersionPreview from '../views/VersionPreview.vue';
import { initSessionGuard } from './init-session-guard';
import { NOT_FOUND_ROUTE_NAME, notFoundExternalRedirectGuard } from './not-found-external-redirect-guard';
import { authCheckGuard } from './auth-check-guard';
import { devProjectEntryGuard } from './dev-project-entry-guard';

const routes: RouteRecordRaw[] = [
  {
    path: '/auth-error',
    name: 'auth-error',
    component: AuthError,
    meta: {
      title: '认证错误 - PuppyCAD',
      requiresAuth: false,
    },
  },
  {
    path: '/projects/:projectId/editor',
    name: 'editor',
    component: Editor,
    meta: {
      title: 'CAD 编辑器 - PuppyCAD',
      requiresAuth: true,
    },
  },
  {
    path: '/projects/:projectId/preview',
    name: 'preview',
    component: Preview,
    meta: {
      title: '项目预览 - PuppyCAD',
      requiresAuth: true,
    },
  },
  {
    path: '/projects/:projectId/version-preview',
    name: 'version-preview',
    component: VersionPreview,
    meta: {
      title: '版本预览 - PuppyCAD',
      requiresAuth: true,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: NOT_FOUND_ROUTE_NAME,
    component: {
      render: () => null,
    },
    meta: {
      requiresAuth: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 注册路由守卫（按顺序执行）
// 顺序语义：会话初始化 -> 认证检查 -> 开发环境首页项目直达 -> 未找到路由外部承接
router.beforeEach(initSessionGuard);
router.beforeEach(authCheckGuard);
router.beforeEach(devProjectEntryGuard);
router.beforeEach(notFoundExternalRedirectGuard);

export default router;
